import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.use(ElementUI);
import { handleTree } from "@/utils/tools";
Vue.prototype.handleTree = handleTree;
Vue.config.productionTip = false;
import { upload } from "@/utils/api.js";
Vue.prototype.$upload = upload;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
